import { FocusEvent } from "react";

/**
 * Selects an input's contents on focus so typing replaces the current value.
 *
 * react-number-format corrects the caret position in a timeout of its own after
 * focus, which collapses an immediate selection — hence the deferred select.
 */
export function selectOnFocus(event: FocusEvent<HTMLInputElement>) {
  const input = event.target;

  setTimeout(() => input.select(), 0);
}
